import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../config/config";
import "../css/register.css";

function Register() {
const navigate = useNavigate();
    const [formData,setFormData]=useState({
        first_name:"",
        last_name:"",
        email:"",
        phone:"",
        password:""
    });

    const handleChange=(e)=>{
        setFormData({...formData,[e.target.name]:e.target.value});
    };

    const handleSubmit=async(e)=>{
        e.preventDefault();

        try{

            const res=await axios.post(`${API_URL}/register`,formData);
alert(res.data.message);

navigate("/login");

        }catch(err){

            alert(err.response?.data?.message || "Registration Failed");

        }

    };

    return(

<div className="register-page">

<div className="register-card">

<h1>🥃 SIP LIQUORS</h1>

<p>Create Your Account</p>

<form className="register-form" onSubmit={handleSubmit}>

<input
type="text"
name="first_name"
placeholder="First Name"
value={formData.first_name}
onChange={handleChange}
required
/>

<input
type="text"
name="last_name"
placeholder="Last Name"
value={formData.last_name}
onChange={handleChange}
required
/>

<input
type="email"
name="email"
placeholder="Email Address"
value={formData.email}
onChange={handleChange}
required
/>

<input
type="text"
name="phone"
placeholder="Phone Number"
value={formData.phone}
onChange={handleChange}
/>

<input
type="password"
name="password"
placeholder="Password"
value={formData.password}
onChange={handleChange}
required
/>

<button className="register-btn">
Create Account
</button>

</form>

<div className="login-link">

Already have an account?

<Link to="/login">
 Login
</Link>

</div>

</div>

</div>

    );

}

export default Register;